import { Application } from "@hotwired/stimulus"
import ToggleController from "./toggle_controller"
import NavbarController from "./navbar_controller"
import ImagePreviewController from "./image_preview_controller"

const application = Application.start()
application.register("toggle", ToggleController)
application.register("navbar", NavbarController)
application.register("image-preview", ImagePreviewController)
